module.exports = __webpack_public_path__ + "img/icon_manejo_de_referidos_over.1425a9fb.svg";